import { ICO } from "../../icons";

const ICON_BY_STATE = { pass: "check", fail: "x", warn: "alert" } as const;
const COLOR_BY_STATE = { pass: "var(--ok)", fail: "var(--fail)", warn: "var(--warn)" } as const;

export function ValidationRule({
  code,
  title,
  state,
  detail,
  location,
}: {
  code: string;
  title: string;
  state: "pass" | "fail" | "warn";
  detail?: string;
  location?: string;
}) {
  return (
    <div className={`rule ${state}`}>
      <svg
        className="rule-ico"
        viewBox="0 0 24 24"
        fill="none"
        stroke={COLOR_BY_STATE[state]}
        strokeWidth={2.2}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        {ICO[ICON_BY_STATE[state]]}
      </svg>
      <div className="grow">
        {/* the code is shown exactly as the API gives it — no package prefix is invented */}
        <div className="rule-id">{code}</div>
        <div className="rule-txt">{title}</div>
        {detail ? <div className="rule-txt">{detail}</div> : null}
        {location ? <div className="rule-x">{location}</div> : null}
      </div>
    </div>
  );
}
